import { render, staticRenderFns } from "./distributeCustom.vue?vue&type=template&id=28651388&scoped=true&"
import script from "./distributeCustom.vue?vue&type=script&lang=js&"
export * from "./distributeCustom.vue?vue&type=script&lang=js&"
import style0 from "./distributeCustom.vue?vue&type=style&index=0&id=28651388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28651388",
  null
  
)

export default component.exports